/**
 * @export
 * @class GuaranteeDeliveryInfoLayer
 * 책임배송정보 레이어
 */
export default class GuaranteeDeliveryInfoLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_guaranteeDeliveryInfoLayer';

    this.render();
  }

  render = () => {
    const sHtml = `<section id="${this.sWrapper}" class="popup popup_layer popup_delivery_info">
                <header class="popup_header">
                    <h3 class="popup_header_title">책임배송제 보상안내</h3>
                    <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                            <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
                        </svg>
                    </button>
                </header>
                <div class="popup_contents">
                    <article class="popup_inner">
                        <p class="text">결제일 +2일 이내 (주말. 공휴일제외) 상품을 받지 못하신 경우, 지연 1일당
                            티몬 적립금 500원을 지급해드립니다. (최대 5,000원과 상품가 중 작은 금액 지급)</p>
                        <ol class="list">
                            <li>출고일의 다음 날을 상품 받은 날로 간주하여 보상금액을 산정합니다.</li>
                            <li>책임배송제는 책임배송보상(배송지연보상) 마크가 부착되어 있는 상품에만 해당됩니다.</li>
                            <li>책임배송 보상금은 별도 신청 절차 없이 배송완료일 다음날 자동지급됩니다. (마이티몬 &gt; 티몬캐쉬•적립금 에서 확인)</li>
                            <li>냉장/냉동/신선 식품의 경우 금요일, 공휴일 전날은 출고가 어려울 수 있으며, 금요일, 주말, 공휴일은 책임배송제 보상일수 산정에서 제외됩니다.</li>
                            <li>지급된 적립금은 지급일+14일까지 사용 가능합니다.</li>
                            <li>책임배송제는 예고 없이 종료될 수 있습니다.</li>
                            <li>묶음배송 상품은 배송번호당 1회 티몬 적립금이 지급됩니다.</li>
                            <li>묶음배송 상품의 경우 분할 출고시, 최초 배송지연 발생건을 기준으로 보상금이 지급되며, 이후 동일 배송번호 내에서 발생한 배송지연은 보상대상에서 제외됩니다.</li>
                        </ol>
                    </article>
                </div>
            </section>`;

    this.welContainer.append(sHtml);
  };

  open = () => {
    TMON.oApp.oUtil.handleOpenLayer({ welTargetLayer: $(`#${this.sWrapper}`) });
  };
}
